import { routes } from "common/routes/routes";
import { flattenRoutes } from "common/routes/routes.utils";
import { DEFAULT_DOCUMENT_TITLE } from "core/types/app.constants";
import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

const routesArray = flattenRoutes(routes);

export const useDocumentTitle = () => {
  const location = useLocation();
  useEffect(() => {
    const match = routesArray.find(route => {
      const pathMatch = matchPath(route.path, location.pathname);
      return !!pathMatch && route.title;
    });

    document.title = match?.title ?? DEFAULT_DOCUMENT_TITLE;
  }, [location]);
};
